// extracted by mini-css-extract-plugin
module.exports = {"logo":"Origin_logo__hbT3L","base":"Origin_base__2zrXm","rain":"Origin_rain__2gPdr"};